import { useState, useRef } from "react";
import Button from "../../../../../Custom/Button/Button";
import LatinicaWarningModal from "../../LatinicaWarningModal";
import { useGlobalContext } from "../../../../../../Context/Context";
import parseBullets from "../../../../../utils/parseBullets";

const styles = {
  button: {
    padding: "10px 20px"
  },
  input: { width: "100%", padding: "10px", fontSize: "14px" }
};

const emptyMera = {
  title: "",
  text: "- "
};

const Ugradi = ({ setNewMere, setCurrentState }) => {
  const [newMera, setNewMera] = useState(emptyMera);
  const [openLatinicaModal, setOpenLatinicaModal] = useState(false);

  const { dictionary } = useGlobalContext();

  const ref = useRef();

  const handleChangeTitle = (e) => {
    setNewMera((prev) => ({ ...prev, title: e.target.value }));
  };

  const handleChangeText = (e) => {
    setNewMera((prev) => ({ ...prev, text: parseBullets(e.target.value) }));
  };

  const handleSacuvaj = () => {
    setNewMere((prev) => [...prev, { ...newMera, id: Math.random() }]);
    setCurrentState("");
  };

  const handleOdustani = () => {
    setNewMera(emptyMera);
    setCurrentState("");
  };

  const handleKeyDown = (e) => {
    const key = e.key;
    if (/^[A-Za-z]$/.test(key)) {
      e.preventDefault();
      setOpenLatinicaModal(true);
    }

    if (e.key === "Enter") {
      e.preventDefault();

      const textarea = ref.current;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;

      const before = newMera.text.substring(0, start);
      const after = newMera.text.substring(end);

      const newValue = before + "\n- " + after;
      setNewMera({ ...newMera, text: newValue });

      requestAnimationFrame(() => {
        const pos = start + 3;
        textarea.setSelectionRange(pos, pos);
      });
    }
  };

  const handleKeyDownTitle = (e) => {
    const key = e.key;
    if (/^[A-Za-z]$/.test(key)) {
      e.preventDefault();
      setOpenLatinicaModal(true);
    }
  };

  const handleCancelLatinica = () => setOpenLatinicaModal(false);

  const isDisabledSacuvaj = newMera.title === "" || newMera.text.length < 3;

  return (
    <>
      <div style={{ maxHeight: "600px", overflowY: "auto" }}>
        <input
          value={newMera.title}
          onChange={handleChangeTitle}
          onKeyDown={handleKeyDownTitle}
          style={styles.input}
        />
        <textarea
          ref={ref}
          value={newMera.text}
          onChange={handleChangeText}
          onKeyDown={handleKeyDown}
          rows={10}
          style={styles.input}
        />
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          marginTop: "20px"
        }}
      >
        <div onClick={handleOdustani} style={{ height: "40px" }}>
          <Button activation={true} style={styles.button}>
            <span
              style={{
                width: "10vw",
                height: "40px",
                fontWeight: "bold",
                alignContent: "center"
              }}
            >
              {" "}
              {dictionary["odustani"]}
            </span>
          </Button>
        </div>
        <div
          onClick={isDisabledSacuvaj ? undefined : handleSacuvaj}
          style={{ height: "40px", opacity: isDisabledSacuvaj ? 0.5 : 1 }}
        >
          <Button
            isDisabled={isDisabledSacuvaj}
            activation={true}
            style={styles.button}
          >
            <span
              style={{
                width: "10vw",
                height: "40px",
                fontWeight: "bold",
                alignContent: "center"
              }}
            >
              {" "}
              {dictionary["sacuvaj"]}
            </span>
          </Button>
        </div>
      </div>
      {openLatinicaModal && (
        <LatinicaWarningModal handleCancel={handleCancelLatinica} />
      )}
    </>
  );
};

export default Ugradi;
